export const consultationNothingLists = {
    text: '표시할 상담이 없습니다.',
    // subText: '새로운 진료를 추가하여, 편리하게 관리해보세요!',
    buttonText: '새로고침',
};
